import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apis from '../../utils/apis';
import httpAction from '../../utils/httpAction';
import { resolveMedia } from '../../utils/media';
import { CardSkeleton, SkeletonText } from '../../components/common/Skeleton';

export default function Blog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');
  const navigate = useNavigate();

  const loadData = async () => {
    setLoading(true);
    const result = await httpAction({ url: `${apis().blogList}?admin=1`, silent: true });
    if (result?.status) setRows(result.list || []);
    setLoading(false);
  };

  useEffect(() => { loadData(); }, []);

  const filtered = useMemo(() => rows.filter((item) => {
    const needle = q.trim().toLowerCase();
    if (!needle) return true;
    return [item.title, item.excerpt, item.category, (item.tags || []).join(', ')].join(' ').toLowerCase().includes(needle);
  }), [rows, q]);

  const deleteHandler = async (id) => {
    const result = await httpAction({ url: `${apis().blogAdd.replace('/add','')}/delete/${id}`, method: 'DELETE' });
    if (result?.status) loadData();
  };

  if (loading) return <div><SkeletonText width="180px" height={28} /><div style={{ marginTop:18 }}><CardSkeleton count={4} height={160} /></div></div>;

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div><h2 style={{ margin:0 }}>Blogs</h2><p style={{ color:'#667085', margin:'6px 0 0' }}>Manage published and draft blog posts with uploaded media.</p></div>
        <button onClick={() => navigate('/admin/blog/add')} style={{ padding:'12px 16px', borderRadius:10, border:'none', background:'#0f5ef7', color:'#fff', fontWeight:700 }}>New Blog Post</button>
      </div>
      <input placeholder="Search blogs..." value={q} onChange={(e)=>setQ(e.target.value)} style={{ width:'100%', maxWidth:360, padding:12, border:'1px solid #d0d5dd', borderRadius:10, marginBottom:18 }} />
      <div style={{ display:'grid', gap:12 }}>
        {filtered.map((item) => (
          <div key={item._id} style={{ background:'#fff', border:'1px solid #edf0f7', borderRadius:16, padding:18, display:'grid', gridTemplateColumns:'100px 1fr auto', gap:16, alignItems:'center' }}>
            <img src={resolveMedia(item.coverImage)} alt={item.title} style={{ width:100, height:80, objectFit:'cover', borderRadius:12 }} />
            <div>
              <div style={{ fontSize:12, fontWeight:700, color:item.status === 'published' ? '#067647' : '#b54708' }}>{item.status?.toUpperCase()}</div>
              <h4 style={{ margin:'6px 0' }}>{item.title}</h4>
              <p style={{ margin:0, color:'#667085' }}>{item.excerpt}</p>
            </div>
            <div style={{ display:'flex', gap:8, alignItems:'start' }}>
              <button onClick={() => navigate(`/admin/blog/add?id=${item._id}`)} style={{ padding:'10px 12px' }}>Edit</button>
              <button onClick={() => deleteHandler(item._id)} style={{ padding:'10px 12px', color:'#b42318' }}>Delete</button>
            </div>
          </div>
        ))}
        {!filtered.length && <div style={{ padding:16, background:'#fff', border:'1px solid #edf0f7', borderRadius:14 }}>No blog posts found.</div>}
      </div>
    </div>
  );
}
